'use client';

import { c as _c } from "react/compiler-runtime";
import { ConfirmationDialog } from '@components/ui/confirmation-dialog';
export interface LargeInsightImportRequest {
  fileCount: number;
  folderCount: number;
}
interface LargeInsightImportDialogProps {
  request: LargeInsightImportRequest | null;
  onResolve: (confirmed: boolean) => void;
}
function describeSelection({
  fileCount,
  folderCount
}: LargeInsightImportRequest) {
  const files = `${fileCount.toLocaleString()} PDFs`;
  if (folderCount === 0) return files;
  const folders = `${folderCount.toLocaleString()} ${folderCount === 1 ? 'folder' : 'folders'}`;
  return `${files} in ${folders}`;
}

/**
 * Asks before a large import starts. Files upload from this
 * tab, so it has to stay open until the last one is sent —
 * processing afterwards runs on the server and needs nothing
 * from the browser.
 */
export function LargeInsightImportDialog(t0) {
  const $ = _c(10);
  const {
    request,
    onResolve
  } = t0;
  const t1 = request !== null;
  let t2;
  let t3;
  if ($[0] !== onResolve) {
    t2 = () => onResolve(false);
    t3 = () => onResolve(true);
    $[0] = onResolve;
    $[1] = t2;
    $[2] = t3;
  } else {
    t2 = $[1];
    t3 = $[2];
  }
  let t4;
  if ($[3] !== request) {
    t4 = request ? <><p>You're importing {describeSelection(request)}. Keep this tab open until every file has uploaded — closing it stops the rest.</p><p className="mt-2">Once uploaded, files keep processing even if you leave.</p></> : null;
    $[3] = request;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== t1 || $[6] !== t2 || $[7] !== t3 || $[8] !== t4) {
    t5 = <ConfirmationDialog isOpen={t1} onClose={t2} onConfirm={t3} title="Start a large import?" contentClassName="sm:max-w-[400px]" description={t4} confirmLabel="Start import" data-sentry-element="ConfirmationDialog" data-sentry-component="LargeInsightImportDialog" data-sentry-source-file="large-insight-import-dialog.tsx" />;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  return t5;
}